<template>
	<div>
		<el-dialog width="30%" title="选择图标" :visible.sync="innerVisible" append-to-body>
			<div class="tubiao_div">
				<!-- <i v-for="(item,index) in icons" :class='item' :style="{ color: (tubiaoId == item ? '#409EFF' :'#606266')}" class="iconfont templateIcon"
				 @click="tubiao(item,index)"></i> -->
				 <div class="templateIcon" v-for="(item,index) in icons" style="display: inline-block;border-radius: 5px;padding: 5px;">
					<img :src="item.imgPath" :title="item.title" style="width: 22px;height: 22px;" @click="tubiao(item.name,index)">
				 </div>
				 <!-- <img :src="require('@/assets/icon/报修.png')" alt=""> -->
			</div>
			<!-- <span slot="footer" class="dialog-footer">
				<el-button @click="innerVisible = false">取 消</el-button>
				<el-button type="primary" @click="searchTb">确 定</el-button>
			</span> -->
		</el-dialog>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		data() {
			return {
				innerVisible: false,
				tubiaoId: '',
				icons:[{
					title: '待办工作',
					name: '待办工作.png',
					imgPath: require('@/assets/icon/待办工作.png')
				}, {
					title: '待审核',
					name: '待审核.png',
					imgPath: require('@/assets/icon/待审核.png')
				}, {
					title: '发起的',
					name: '发起的.png',
					imgPath: require('@/assets/icon/发起的.png')
				}, {
					title: '服务台创建',
					name: '服务台创建.png',
					imgPath: require('@/assets/icon/服务台创建.png')
				}, {
					title: '服务台接收',
					name: '服务台接收.png',
					imgPath: require('@/assets/icon/服务台接收.png')
				}, {
					title: '服务台任务',
					name: '服务台任务.png',
					imgPath: require('@/assets/icon/服务台任务.png')
				}, {
					title: '工作记录',
					name: '工作记录.png',
					imgPath: require('@/assets/icon/工作记录.png')
				}, {
					title: '进行中',
					name: '进行中.png',
					imgPath: require('@/assets/icon/进行中.png')
				}, {
					title: '默认图标',
					name: '默认图标.png',
					imgPath: require('@/assets/icon/默认图标.png')
				}, {
					title: '任务查询',
					name: '任务查询.png',
					imgPath: require('@/assets/icon/任务查询.png')
				}, {
					title: '任务管理',
					name: '任务管理.png',
					imgPath: require('@/assets/icon/任务管理.png')
				}, {
					title: '任务量统计',
					name: '任务量统计.png',
					imgPath: require('@/assets/icon/任务量统计.png')
				}, {
					title: '任务一览',
					name: '任务一览.png',
					imgPath: require('@/assets/icon/任务一览.png')
				}, {
					title: '设备',
					name: '设备.png',
					imgPath: require('@/assets/icon/设备.png')
				}, {
					title: '所有任务',
					name: '所有任务.png',
					imgPath: require('@/assets/icon/所有任务.png')
				}, {
					title: '通讯录',
					name: '通讯录.png',
					imgPath: require('@/assets/icon/通讯录.png')
				}, {
					title: '完成的',
					name: '完成的.png',
					imgPath: require('@/assets/icon/完成的.png')
				}, {
					title: '我创建的',
					name: '我创建的.png',
					imgPath: require('@/assets/icon/我创建的.png')
				}, {
					title: '我参与的',
					name: '我参与的.png',
					imgPath: require('@/assets/icon/我参与的.png')
				}, {
					title: '我的评价',
					name: '我的评价.png',
					imgPath: require('@/assets/icon/我的评价.png')
				}, {
					title: '我的任务',
					name: '我的任务.png',
					imgPath: require('@/assets/icon/我的任务.png')
				}, {
					title: '我分派的',
					name: '我分派的.png',
					imgPath: require('@/assets/icon/我分派的.png')
				}, {
					title: '我关注的',
					name: '我关注的.png',
					imgPath: require('@/assets/icon/我关注的.png')
				}, {
					title: '我接收的',
					name: '我接收的.png',
					imgPath: require('@/assets/icon/我接收的.png')
				}, {
					title: '我流转的',
					name: '我流转的.png',
					imgPath: require('@/assets/icon/我流转的.png')
				}, {
					title: '我完成的',
					name: '我完成的.png',
					imgPath: require('@/assets/icon/我完成的.png')
				}, {
					title: '值班',
					name: '值班.png',
					imgPath: require('@/assets/icon/值班.png')
				}, {
					title: '主责',
					name: '主责.png',
					imgPath: require('@/assets/icon/主责.png')
				}, {
					title: '子任务',
					name: '子任务.png',
					imgPath: require('@/assets/icon/子任务.png')
				}, {
					title: '自定义图标',
					name: '自定义图标.png',
					imgPath: require('@/assets/icon/自定义图标.png')
				}, {
					title: '自定义图标2',
					name: '自定义图标2.png',
					imgPath: require('@/assets/icon/自定义图标2.png')
				}, {
					title: '任务上报',
					name: '任务上报.png',
					imgPath: require('@/assets/icon/任务上报.png')
				}],
			}
		},
		computed: {
			...mapState({
				// icons: state=>state.task.icons
			})
		},
		components:{
			
		},
		methods:{
			tubiao(val, index){
				console.log(val)
				this.tubiaoId = val;
				this.$emit('getVal',val);
				this.innerVisible = false
			}
		}
	}
</script>

<style scoped>
	.templateIcon:hover {
		background-color: #c6e2ff;
	}
</style>
